export const Loader = ({ width = 40 }) => {
  const size = typeof width === 'number' ? width : 40;
  const borderWidth = Math.max(2, Math.round(size / 10));
  
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          width: size,
          height: size,
          border: `${borderWidth}px solid #f3f3f3`,
          borderTop: `${borderWidth}px solid #3498db`,
          borderRadius: "50%",
          animation: "spin 1s linear infinite",
        }}
      />
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};
